module.exports = __webpack_public_path__ + "img/paper1.a4929a90.png";